module.exports = __webpack_public_path__ + "img/Cheer Megaphone68.02bebc99.jpg";